import { render } from "./ProfiletwoComponent.vue?vue&type=template&id=13eea5cc"
import script from "./ProfiletwoComponent.vue?vue&type=script&lang=js"
export * from "./ProfiletwoComponent.vue?vue&type=script&lang=js"

import "./ProfiletwoComponent.vue?vue&type=style&index=0&id=13eea5cc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__